import { MealOptionsSection } from '../MealOptionsSection';
import { RsvpQuestionsSection } from '../RsvpQuestionsSection';
import type { CampaignStepProps } from './CampaignDetailsStep';

/**
 * Step 3 (the office's): the event's meal options, which every campaign of
 * the event offers, and this campaign's own questions. Each saves as it is
 * changed.
 */
export function CampaignQuestionsStep({ campaign, eventId, onNext }: CampaignStepProps) {
  return (
    <div className="space-y-6">
      <section>
        <MealOptionsSection eventId={eventId} />
        <p className="mt-1 text-xs text-gray-500">
          Meals belong to the event, so every invitation for it offers the same ones.
        </p>
      </section>
      <section>
        <RsvpQuestionsSection campaignId={campaign.id} />
      </section>
      {onNext && (
        <div className="flex justify-end border-t border-gray-100 pt-3">
          <button
            type="button"
            onClick={onNext}
            className="px-4 py-2 text-sm text-white bg-primary-600 rounded-lg hover:bg-primary-700"
          >
            Continue
          </button>
        </div>
      )}
    </div>
  );
}
